import { ISelectOption } from "~/shared/ui/Fields/types";

export const listToSelectOptions = <ItemType extends Record<string, any>>(
  array: ItemType[],
  mask: { label: keyof ItemType; value: keyof ItemType }
): ISelectOption[] =>
  Array.isArray(array)
    ? array.map((item) => ({
        label: item[mask.label],
        value: item[mask.value],
      }))
    : [];
